import { router } from '@/router';
import type { PiniaPlugin } from 'pinia';
import { markRaw } from 'vue';
import type { Router } from 'vue-router';

export const Globals: PiniaPlugin = ({ store }) => {
    // important! dont add a $router here
    store.router = markRaw(router);
};

declare module 'pinia' {
    interface PiniaCustomProperties {
        // type the router added by the plugin above (#adding-new-external-properties)
        router: Router,
    }
}
